'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diff;
var _immutable = require('immutable');
var _lcs = require('./lcs');
var isMap = _immutable.Map.isMap;
var isIndexed = _immutable.Iterable.isIndexed;
function op(operation, path, value) {
  if (operation === 'remove') {
    return {
      op: operation,
      path: path
    };
  }
  return {
    op: operation,
    path: path,
    value: value
  };
}
function mapDiff(a, b) {
  var path = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
  var ops = [];
  if ((0, _immutable.is)(a, b)) {
    return ops;
  }
  var areIndexed = isIndexed(a) && isIndexed(b);
  var lastKey = null;
  var removeKey = null;
  if (a.forEach) {
    a.forEach(function (aValue, aKey) {
      if (b.has(aKey)) {
        if (isMap(aValue) && isMap(b.get(aKey))) {
          ops = ops.concat(mapDiff(aValue, b.get(aKey), path.concat(aKey)));
        } else if (isIndexed(b.get(aKey)) && isIndexed(aValue)) {
          ops = ops.concat(sequenceDiff(aValue, b.get(aKey), path.concat(aKey)));
        } else {
          var bValue = b.get ? b.get(aKey) : b;
          var areDifferentValues = aValue !== bValue;
          if (areDifferentValues) {
            ops.push(op('replace', path.concat(aKey), bValue));
          }
        }
      } else if (areIndexed) {
        removeKey = lastKey != null && lastKey + 1 === aKey ? removeKey : aKey;
        ops.push(op('remove', path.concat(removeKey)));
        lastKey = aKey;
      } else {
        ops.push(op('remove', path.concat(aKey)));
      }
    });
  }
  b.forEach(function (bValue, bKey) {
    if (a.has && !a.has(bKey)) {
      ops.push(op('add', path.concat(bKey), bValue));
    }
  });
  return ops;
}
function sequenceDiff(a, b) {
  var path = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
  var ops = [];
  if ((0, _immutable.is)(a, b)) {
    return ops;
  }
  if (b.count() > 100) {
    return mapDiff(a, b, path);
  }
  var lcsDiff = (0, _lcs.diff)(a, b);
  var pathIndex = 0;
  lcsDiff.forEach(function (diff) {
    if (diff.op === '=') {
      pathIndex++;
    } else if (diff.op === '!=') {
      if (isMap(diff.val) && isMap(diff.newVal)) {
        var mapDiffs = mapDiff(diff.val, diff.newVal, path.concat(pathIndex));
        ops = ops.concat(mapDiffs);
      } else {
        ops.push(op('replace', path.concat(pathIndex), diff.newVal));
      }
      pathIndex++;
    } else if (diff.op === '+') {
      ops.push(op('add', path.concat(pathIndex), diff.val));
      pathIndex++;
    } else if (diff.op === '-') {
      ops.push(op('remove', path.concat(pathIndex)));
    }
  });
  return ops;
}
function primitiveTypeDiff(a, b) {
  var path = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
  if (a === b) {
    return [];
  } else {
    return [op('replace', path, b)];
  }
}
function diff(a, b, path) {
  if (isIndexed(a) && isIndexed(b)) {
    return (0, _immutable.fromJS)(sequenceDiff(a, b));
  }
  if (isMap(a) && isMap(b)) {
    return (0, _immutable.fromJS)(mapDiff(a, b));
  }
  return (0, _immutable.fromJS)(primitiveTypeDiff(a, b, path));
}